import { put, takeEvery } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import {
  queryDownloadIdsSuccess,
  queryDownloadIdsFailure,
  updateDownloadIds,
  updateDownloadProgress,
} from '../actions';
import DirectDownloadActionTypes from '../types';
import { downloadFile } from 'utils/helpers';

const { API_BASE_URL } = urls || {};

export function* queryAllDownloadIds({ payload: { ids, allIds } }) {
  const response = yield Promise.all(
    ids.map(async (downloadId) => {
      const apiResponse = await request({
        method: 'get',
        url: `${API_BASE_URL}/tasks/${downloadId?.id}`,
      });
      return apiResponse;
    })
  );

  const successfulResponses = response.filter((res) => res?.success);

  if (successfulResponses.length === 0) {
    Notify(`Failed to download: ${response[0]?.message || 'Unknown error'}`, {
      position: 'top-right',
      status: 'error',
    });
    yield put(queryDownloadIdsFailure(response[0]?.message));
    return;
  }

  const tasks = successfulResponses.map((res) => res.raw).filter(Boolean);

  yield put(
    updateDownloadProgress(
      tasks.map((task) => ({
        id: task.id,
        progress: task.complete ? 100 : task.progress,
        complete: task.complete,
        error: task.error,
      }))
    )
  );

  const readyForDownload = tasks.filter((task) => task.complete === true);
  const failedTasks = tasks.filter((task) => Boolean(task.error));

  const resolvedIds = new Set([
    ...readyForDownload.map((task) => task.id),
    ...failedTasks.map((task) => task.id),
  ]);

  const remainingIds = allIds.filter((item) => !resolvedIds.has(item?.id));

  yield put(queryDownloadIdsSuccess());
  yield put(updateDownloadIds(remainingIds));

  failedTasks.forEach((task) => {
    Notify(`Export failed: ${task.error}`, {
      position: 'top-right',
      status: 'error',
    });
  });

  for (let i = 0; i < readyForDownload.length; i++) {
    downloadFile(
      `${API_BASE_URL}${readyForDownload[i].result}`,
      +decodeURIComponent(readyForDownload[i].result.split('/').pop())
    );
  }
}

export function* onQueryDownloadIds() {
  yield takeEvery(
    DirectDownloadActionTypes.QUERY_DOWNLOAD_IDS_START,
    queryAllDownloadIds
  );
}
